import { formatDataTest } from '@/common/dataTest/DataTest';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mui/material';

export const RowIcon = ({ iconKey, icon, color, toolTip }) => {
  return (
    <Tooltip title={toolTip} data-test-id={formatDataTest('row-icon', iconKey)}> 
      <FontAwesomeIcon icon={icon} color={color} />
    </Tooltip>
  )
}